import { useTourGames } from './useTourGames';
export default useTourGames;